export const CodigoAcuracia = {
  ACURACIA80: 'MAIOR_80',
  ACURACIA51A80: 'DE_51_A_80',
  ACURACIA50: 'MENOR_50'
};
